module.exports = __webpack_public_path__ + "static/media/invoice-pay.df8199b4.svg";